import { IdType } from "./BaseTypes";
import { FileType } from "./File";

export enum UserRole {
  Admin,
  Moderator,
  User,
  Unverified,
}

export type UserAuthentication =
  | { ok: true; sub: IdType; token: string }
  | { ok: false };

export type AuthTokenPayload = {
  sub: string;
  iat: number;
  exp: number;
};

export type SessionTokenPayload = {
  sub: string;
  role: UserRole;
  verified: boolean;
  iat: number;
  exp: number;
};

export type UserSession =
  | {
      ok: true;
      token: string;
      sub: IdType;
      verified: boolean;
      role: UserRole;
      iat: number;
      exp: number;
    }
  | { ok: false };

export type UserType = {
  _id: IdType;
  username: string;
  description: string;
  avatarUrl?: FileType;
  bookmarkedItems?: IdType[];
  bookmarkedCategories?: IdType[];
};

export type UserPutType = Partial<UserType> & { _id: IdType };
